import type { User } from '@sentry/node'
import { LucideHome } from 'lucide-react'
import { useState } from 'react'
import type { MapCollection } from 'react-map-gl/dist/esm/components/use-map'
import { ControlTooltip } from '~/components/common'
import { Button } from '~/components/ui'
import { cn } from '~/utils'
import SetMapHome from './SetHome'

type MapHomeProps = {
  mapRef: MapCollection<mapboxgl.Map>
  setInitialView: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  user: User | null
}

export default function MapHome({
  mapRef,
  setInitialView,
  user,
}: MapHomeProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  if (!user || !mapRef.current) {
    return null
  }

  return (
    <div className="relative flex w-10 justify-end overflow-visible">
      <div
        className={cn(
          'flex flex-col items-center gap-2 rounded-md shadow-md',
          isOpen &&
            'bg-background/65 backdrop-blur supports-[backdrop-filter]:bg-background/65'
        )}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}>
        <ControlTooltip side="right" text="Map home">
          <Button
            id="map-home"
            variant="map"
            size="map"
            onClick={setInitialView}
            className="shadow-none">
            <LucideHome className="h-5 w-5" />
          </Button>
        </ControlTooltip>
        {isOpen && <SetMapHome map={mapRef.current} />}
      </div>
    </div>
  )
}
